export const awsConfig = {
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_USER_POOL_ID,
  clientId: process.env.REACT_APP_CLIENT_ID,
  apiUrl: process.env.REACT_APP_API_URL
};

export default awsConfig;

